<template>
  <div class="bg-container w-100 py-5">
    <h3 class="cm-title text-blue-v2">Celebraciones de hoy</h3>
    <p class="py-4 home-subtitle">Entérate de los cumpleaños, nuevos ingresos y nacimientos.</p> 
    <div>
      <v-tabs class="bg-white" v-model="active" color="#F4F4FF" dark height="50">
        <v-tab 
          v-for="(item, index) in items"
          :key="index"
          ripple 
          class="tab-title"
          :class="{'tab-active': active === index, 'tab-inactive': active !== index}"
          v-custom-style="active === index">
          <p class="item_menu">
            {{ item }}
            <i class="material-icons" @click="addToUrl(item)">add_circle</i>
          </p>
        </v-tab>
        <v-tabs-items v-model="active">
          <v-tab-item v-for="(tab, index) in items" :key="index">
            <v-card elevation="1" class="rounded-card">
              <v-layout row wrap class="cm-container-card">
                <template v-if="getItemsForTab(tab).length > 0">
                  <v-flex xs12 sm6 md3 lg3 pa-2 my-4 v-for="(item, i) in getItemsForTab(tab)" :key="i">
                    <CelebrationCard
                      :image="item.image"
                      :title="item.name"
                      :subtitle="getSubtitle(tab, item)"
                      :email="item.email"
                      :color="item.color"
                    />
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12 class="my-4 pa-2" style="height: 320px;">
                    <p class="no-items-message">No hay {{ tab }} disponibles.</p>
                  </v-flex>
                </template>
              </v-layout>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import CelebrationCard from './CelebrationCard.vue';

export default {
  components: {
    CelebrationCard
  },
  directives: {
    customStyle: {
      update(el, binding) {
        if (binding.value) {
          el.style.borderTopColor = '#28385C';
        } else {
          el.style.borderTopColor = '#919199';
        }
      }
    }
  },
  data() {
    return {
      items: ['Cumpleaños de hoy', 'Nuevos ingresos', 'Nacimientos'],
      active: 0,
      birthdays: [],
      newIncomes: [],
      births: []
    };
  },
  methods: {
    async fetchData() {
      const { data: homeBirthdays } = await axios.get(
        process.env.VUE_APP_API_URL + "/birthdays/get_home_birthdays"
      );
      const { data: homeIncomes } = await axios.get(
        process.env.VUE_APP_API_URL + "/welcome/get_home_welcome"
      );
      const { data: homeBirths } = await axios.get(
        process.env.VUE_APP_API_URL + "/births/get_home_births"
      );

      this.birthdays = homeBirthdays.map(user => ({
        image: user.image,
        name: user.full_name,
        subtitle: user.company,
        email: user.email,
        color: user.color
      }));

      this.newIncomes = homeIncomes.map(user => ({
        image: user.image,
        name: user.full_name,
        subtitle: user.company,
        email: user.email,
        color: user.color
      }));

      this.births = homeBirths.map(birth => ({
        image: birth.photo,
        name: birth.child_full_name,
        subtitle: `${birth.father}`,
        email: birth.email,
        color: birth.color
      }));
    },
    getItemsForTab(tab) {
      switch (tab) {
        case 'Cumpleaños de hoy':
          return this.birthdays;
        case 'Nuevos ingresos':
          return this.newIncomes;
        case 'Nacimientos':
          return this.births;
      }
    },
    getSubtitle(tab, item) {
      if (tab === 'Nacimientos') {
        return `${item.subtitle}`;
      }
      return item.subtitle;
    },
    addToUrl(item) {
      const path = this.getUrlForTab(item);
      this.$router.push(path);
    },
    getUrlForTab(item) {
      switch (item) {
        case 'Cumpleaños de hoy':
          return '/celebremos-cumpleanos';
        case 'Nuevos ingresos':
          return '/celebremos-bienvenidos';
        case 'Nacimientos':
          return '/celebremos-nacimientos';
        default:
          return '/';
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped>
.bg-container {
  background-color: #F4F4FF !important;
  margin: auto;
}
.bg-white{
  background-color: white;
}
.home-subtitle{
  font-size: 1rem;
  color: #49494D;
  margin: 0;
}
.item_menu{
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1rem;
  text-transform: none;
  margin: 0;
}
.item_menu i.material-icons {
  font-size: 1.25rem;
  margin-left: 8px;
}
.v-tabs__item .v-tabs__item--active {
  max-width:  150px !important;
}
.tab-title {
  border-top: 0.25rem solid;
  transition: border-color 0.3s ease;
  margin: 0 10px;
  border-top-left-radius: 5%;
  border-top-right-radius: 5%;
  border-bottom: 0.0625rem solid #E6E6EB;
  border-left: 0.0625rem solid #E6E6EB;
  border-right: 0.0625rem solid #E6E6EB;
  justify-content: center;
  display: flex;
  align-items: center;
}
.btn-more-celebrations {
  border-bottom: 0.0625rem solid black;
  text-transform: none;
  font-size: 1rem;
  font-weight: 600;
}
.cm-container-card {
  border-radius: 1.875rem;
}

.tab-active {
  color: #28385C;
  border-top-color: #28385C;
}

.tab-inactive {
  color: #919199; 
  border-top-color: #919199;
}

.no-items-message {
  text-align: center;
  font-size: 1.125rem;
  color: #49494D;
  padding: 1.25rem;
  width: 100%;
}

#app > div > div:nth-child(3) > main > div > div > div > div:nth-child(3) > div > div > div > div.v-tabs__bar.theme--dark > div > div{
  background-color: #F4F4FF;
}

#app > div > div:nth-child(3) > main > div > div > div > div:nth-child(3) > div > div > div > div.v-tabs__bar.theme--dark > div > div > div.v-tabs__div.tab-title {
  background-color: #fff;
  width: 200px !important;
}
#app > div > div:nth-child(3) > main > div > div > div > div:nth-child(3) > div > div > div > div.v-tabs__bar.theme--dark > div > div > div.v-tabs__div{
  margin-left: 0px;
}
div.v-tabs__div.tab-title.tab-active{
  border-bottom: none !important ;
}

.rounded-card {
  border-radius: 0.625rem;
  overflow: hidden;
}
</style>
